import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ToastService } from 'src/app/shared/components/toast/toast.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
  showError: boolean = false;
  errorMessage!: string;
  isLoader = false;
  emailInvalid!: boolean;
  user: any;
  @Input() id?: string;
  message!: string;
  isMsgSent = false;

  constructor(
    private _authService: AuthService,
    private toastService: ToastService
  ) {
    this.user = {
      login: '',
    };
  }

  sendResetPassword(user: any, isMobile: boolean, isInvalid?: any) {
    this.showError = false;

    this._authService.resetPassword(this.user).subscribe((response: any) => {
      if (response.code === 202) {
        this.showError = false;
        this.isMsgSent = true;
        this.showSuccess('Votre mot de passe a été réinitialisé');
      }
      else {
        this.showError = true;
        this.errorMessage = response['message'];
      }
    });
  }

  showSuccess(msg: any) {
    this.toastService.show(msg, {
      classname: 'bg-success text-light',
      delay: 5000,
    });
  }

  showDanger(dangerTpl: any) {
    this.toastService.show(dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 5000,
    });
  }
}
